import { t } from "@lingui/macro";
import * as React from "react";
import { G, Circle, Path, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const BasketballIcon = (props: IconProps) => {
  const clipPathId = React.useId();

  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      color="#001A19"
      title={t`Basketball`}
      {...props}
    >
      <G
        stroke="currentColor"
        strokeLinecap="round"
        fill="none"
        strokeWidth={1.4}
        clipPath={`url(#${clipPathId})`}
      >
        <Circle cx={8} cy={8} r={7} />
        <Path d="M14.903 8.875C14.348 6.392 11.47 4.5 8 4.5c-3.468 0-6.348 1.892-6.903 4.375M8 1v14" />
        <Path d="M11.938 2.75c-.438.128-1.313.693-1.313 1.925 0 3.325 2.625 5.075 2.625 7.7M4.063 2.75c.437.128 1.312.693 1.312 1.925 0 3.325-2.625 5.075-2.625 7.7" />
      </G>
      <Defs>
        <ClipPath id={clipPathId}>
          <Path fill="#fff" d="M0 0h16v16H0z" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};
